import { Box } from "@mui/material";
import ActionButton from "components/basic/ActionButton";
import { useState } from "react";
import MenuDialog from "components/dialog/MenuDialog";

/**
 * Um botão único na página, que mostra um diálogo com uma lista de ações para ser selecionadas.
 * É exibido no canto em telas pequenas.
 *
 * Devem ser especificados os parâmetros de MenuDialog (menuItems e onClose).
 * Veja a documentação de MenuDialog.
 */
export default function ActionMenu({ label, icon, sx, ...props }) {
    const [dialog, setDialog] = useState();

    function handleShowDialog() {
        dialog.setOpen(true);
    }

    return (
        <Box sx={sx}>
            <ActionButton label={label} icon={icon} onClick={handleShowDialog} {...props} />

            <MenuDialog title={label} setDialog={setDialog} {...props} />
        </Box>
    );
}
